module.exports = __webpack_public_path__ + "static/dynamic-form-aa44eae136ad165d0b3835580a8949e6.svg";